import React from 'react'

import clsx from 'clsx'

import Typography from 'components/Typography'

/** @type {import("./types").default} */
const Link = ({ newWindow = false, href, children, onClick, className, ...props }) => {
  const otherAttributes = newWindow
    ? {
        target: '_blank',
        rel: 'noopener',
      }
    : {}

  return (
    <Typography
      onClick={onClick}
      className={clsx('Link', className)}
      href={href}
      component="a"
      variant="body-sm"
      {...otherAttributes}
      {...props}
    >
      {children}
    </Typography>
  )
}

export default Link
